import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const COUNTRY_TAX_REQUEST = 'sherrinford/country_tax/list/COUNTRY_TAX_REQUEST'
export const COUNTRY_TAX_SUCCESS = 'sherrinford/country_tax/list/COUNTRY_TAX_SUCCESS'
export const COUNTRY_TAX_ERROR = 'sherrinford/country_tax/list/COUNTRY_TAX_ERROR'

export const IS_LOADING = 'sherrinford/country_tax/list/IS_LOADING'
export const DATA = 'sherrinford/country_tax/list/DATA'

const initialState = {
  data: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
}

export default createReducer(initialState, {
  [COUNTRY_TAX_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [COUNTRY_TAX_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [COUNTRY_TAX_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),
})

export const getCountryTaxes = (qs) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      COUNTRY_TAX_REQUEST,
      COUNTRY_TAX_SUCCESS,
      COUNTRY_TAX_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/country_tax',
      authorization: `${token}`,
      payloads: qs,
      universeHost: true,
    },
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})
